/**
 * If we want to implement timer with a self made implementation
 * or with a lighter library. For ex. Moment(69.kb),
 * Luxon(17.2kb), date-fns(13.4 w/o tree shaking),
 * dayjs(2.6k w/o plugins)
 * All above gziped.
 */
// export * from './momentTimer';

const moment = require('moment')
require('moment-precise-range-plugin')
import { isDurationObject, hhmm, inMinutes } from '@/micro/time/timeTools'

/**
 * Fn: elapsed = end - start =
 * 	   2019-07-13T10:35:00.328Z - 2019-07-13T10:31:00.328Z = {hh: 0, mm:4}
 *     1563720224098 - 'Sun Jul 21 2019 09:43:44 GMT- ...' = {hh: 0, mm:0}
 *
 * @private
 * @param {string|number} `start` Text|number representing a point in time
 * @param {string|number} `end` Text|number representing a point in time
 * @returns {hh, mm} The time without Date context
 */
const elapsedOfTimes = (start, end) => {
  const elapsed = moment.preciseDiff(moment(end), moment(start), true)
  return { hh: elapsed.hours, mm: elapsed.minutes }
}

/**
 * Fn: duration = to - from =
 * 		{hh: 0, mm:35 } - {hh: 0, mm:31 } = {hh: 0, mm:4}
 *
 * @private
 * @param {object} `from` {hh, mm}
 * @param {object} `to` {hh, mm}
 * @returns {object} The duration between two hours without date context
 */
const elapsedOfDurations = (iFrom, iTo) => {
  const from = isDurationObject(iFrom) ? iFrom : hhmm(iFrom)
  const to = isDurationObject(iTo) ? iTo : hhmm(iTo)
  const fromDuration = moment.duration({ hour: from.hh, minute: from.mm })
  const toDuration = moment.duration({ hour: to.hh, minute: to.mm })
  const duration = toDuration.clone().subtract(fromDuration)
  return { hh: duration.hours(), mm: duration.minutes() }
}

/**
 * @public
 */
const elapsed = {
  /**
   * @param {string} start Datetime in string
   * @param {string} end Datetime in string
   */
  ofTimes: (start, end) => {
    return elapsedOfTimes(start, end)
  },
  /**
   * @param {Object|String} from hh:mm
   * @param {Object|String} to hh:mm
   */
  ofDurations: (from, to) => {
    return elapsedOfDurations(from, to)
  }
}

/**
 * Alorigthm: start(8:00), end(8:15), expected(0:15)
 * 	elapsed = end - start = 8:15 - 8:00
 * 	remaining = expected - ellapsed = 0:30 - 0:15
 *
 * @public
 * @param {Date|number} Start time period
 * @param {Date|number} End time period
 * @param {hh, mm} `expected` The expected time duration
 * @returns {object} {hh, mm} The remaining time in the timer
 */
const remaining = (start, end, { hh, mm }) => {
  const effectiveDuration = elapsedOfTimes(start, end)
  const residual = elapsedOfDurations(effectiveDuration, { hh, mm })
  return residual
}

/**
 *
 * @param {{hh, mm}} remaining
 * @returns bool
 */
const stillRemaining = duration => inMinutes.ofObject(duration) > 0

/**
 * Import them as module or as inviduals for tree shaking
 */
export { elapsed, remaining, stillRemaining }
